import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const UpdateSitesAction = createAsyncThunk("updateSites",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await doPost(urls?.updateSites, payload);
            return response;
        } catch (error) {
            return rejectWithValue(error)
        }
    })

const UpdateSitesSlice = createSlice({
    name: "updateSites",
    initialState: {
        isLoading: false,
        data: {},
        error: null,
        success: false
    },
    reducers: {
        UpdateSitesReset: () => {
            return {
                isLoading: false,
                data: false,
                error: null,
                success: false,
            };
        },
    },
    extraReducers: {
        [UpdateSitesAction.pending]: (state) => {
            state.isLoading = true;
            state.error = null;
            state.success = false;
        },
        [UpdateSitesAction.fulfilled]: (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
            state.error = null;
            state.success = true;
        },
        [UpdateSitesAction.rejected]: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload;
            state.success = false;
        },
    }
})

export const { UpdateSitesReset } = UpdateSitesSlice.actions
export default UpdateSitesSlice.reducer;